export default __webpack_public_path__ + "static/media/profile-faqihah.f903be9b.png";